module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flat-index",
    attrs: {
      "id": "wrapper"
    }
  }, [_c('div', {
    staticClass: "fi-pc helpcenter-container"
  }, [_c('div', {
    staticClass: "fi-main"
  }, [_c('fi-header'), _vm._v(" "), _c('div', {
    staticClass: "helpcenter"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "help-content"
  }, [_c('ul', _vm._l((_vm.helpList), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "h-top",
      on: {
        "click": function($event) {
          return _vm.tmpHandle(index)
        }
      }
    }, [_c('i', {
      staticClass: "parentTri",
      class: {
        'active': _vm.activeArr[index]
      }
    }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('div', {
      staticClass: "help-item",
      class: {
        'active': _vm.activeArr[index]
      }
    }, [_c('p', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  }), 0)])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "question fl"
  }, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    attrs: {
      "placeholder": "请输入您的问题",
      "type": "text",
      "name": "",
      "value": ""
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    attrs: {
      "placeholder": "请输入您的问题描述"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "flat-btn",
    on: {
      "click": _vm.sendHandle
    }
  }, [_c('span', [_vm._v("提交")]), _c('i')])])], 1), _vm._v(" "), _c('fi-footer')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ab-title fl"
  }, [_c('h1', [_vm._v("01")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text"
  }, [_c('a', [_vm._v("在线客服")]), _vm._v(" "), _c('p', [_vm._v("Online Service")])])]), _vm._v(" "), _c('div', {
    staticClass: "nr fl"
  }, [_vm._v("点击在线咨询按钮，连接人工客服。")]), _vm._v(" "), _c('div', {
    staticClass: "fl"
  }, [_c('div', {
    staticClass: "online-consult"
  }, [_c('a', {
    attrs: {
      "href": "https://im2.zhongan.io/zaim/?accessId=1597999116941&tenantID=1514946886000043&color=yellow&themeID=DD001&channelId=94&subject=点点业务&biz=手网"
    }
  }, [_vm._v("在线咨询")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ab-title fl"
  }, [_c('h1', [_vm._v("02")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text ml"
  }, [_c('a', [_vm._v("常见问题")]), _vm._v(" "), _c('p', [_vm._v("Common Problem")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "ab-title fl"
  }, [_c('h1', [_vm._v("03")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text ml"
  }, [_c('a', [_vm._v("获取支持")]), _vm._v(" "), _c('p', [_vm._v("Common Problem")])])]), _vm._v(" "), _c('div', {
    staticClass: "nr fl"
  }, [_vm._v("客服热线：4000666122(工作日9:00-18:00)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ab-title fl"
  }, [_c('h1', [_vm._v("04")]), _vm._v(" "), _c('div', {
    staticClass: "ab-text ml"
  }, [_c('a', [_vm._v("意见反馈")]), _vm._v(" "), _c('p', [_vm._v("Suggestions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24794792"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/HelpCenter.vue
// module id = 367
// module chunks = 1